var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"home-button",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.icon}}),_c('p',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }